import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Box, Button, Container, Paper, Typography } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const ConfirmEmailChangePage = () => {
  const query = useQuery();
  const token = query.get('token') || '';
  const navigate = useNavigate();
  const { confirmEmailChange, logout } = useAuth();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!token) {
      setError('Invalid or expired email confirmation link.');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');
    const result = await confirmEmailChange({ token });
    if (result?.success) {
      setMessage(result.message || 'Email updated successfully.');
      if (result.forceLogout) {
        logout();
      }
    } else {
      setError(result?.message || 'Unable to confirm email change.');
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="xs">
      <Paper sx={{ p: 3, mt: 8 }}>
        <Typography variant="h5" gutterBottom>
          Confirm Email Change
        </Typography>
        {!token ? (
          <Alert severity="error" sx={{ mt: 2 }}>
            The email confirmation link is invalid or has expired.
          </Alert>
        ) : (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Confirm that you want to update the email address on your account.
            </Typography>
            {message && (
              <Alert severity="success" sx={{ mb: 2 }}>
                {message}
              </Alert>
            )}
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            <Box>
              <Button variant="contained" fullWidth onClick={handleConfirm} disabled={loading}>
                {loading ? 'Confirming...' : 'Confirm Email Change'}
              </Button>
              <Button fullWidth sx={{ mt: 1 }} onClick={() => navigate('/login')}>
                Back to Login
              </Button>
            </Box>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default ConfirmEmailChangePage;
